module.exports = __webpack_public_path__ + "images/marketing/peeps/likes/jackie_dasso.jpg";